module.exports = __webpack_public_path__ + "img/logo-lateral.61da452b.png";